export enum MarketingConsent {
    EMAIL = 'email',
    SMS = 'sms'
}